import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const BecsBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string().regex(/^[a-zA-Z0-9\\s]{4,34}$/, { message: 'Account Number should contain 4 to 34 letters or digits' }),
        bsbCode: z.string().regex(/^\d{3}-?\d{3}$/, { message: 'BSB Code should contain 6 to 7 digits' }),
    }),
);

export class BecsBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    bsbCode: string;
}
